// import React, { useContext, useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";

// const colors = [
//   "#0000FF", "#ff7687", "#f87171", "#fb923c", "#facc15", "#4ade80",
//   "#34d399", "#2dd4bf", "#38bdf8", "#60a5fa", "#818cf8", "#a78bfa",
//   "#e879f9", "#f472b6", "#f9a8d4", "#c084fc", "#fcd34d", "#86efac",
//   "#5eead4", "#67e8f9"
// ];

// const TaskLabel = () => {
//   const { user } = useContext(AuthContext);
//   const [taskLabels, setTaskLabels] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFields, setShowFields] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [labelForm, setLabelForm] = useState({ name: "", color: colors[0] });
//   const [editingLabel, setEditingLabel] = useState(null);
//   const [confirmDeleteId, setConfirmDeleteId] = useState(null);
//   const token = localStorage.getItem("token");
//   const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//   const fetchTaskLabels = useCallback(async () => {
//     try {
//       const response = await axios.get(`${API_URL}/api/taskLabel/company/${companyId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setTaskLabels(response.data);
//     } catch (error) {
//       console.error("Error fetching task labels", error);
//     }
//   }, [companyId, token]);

//   useEffect(() => {
//     fetchTaskLabels();
//   }, [fetchTaskLabels]);

//   const handleSave = async () => {
//     try {
//       if (editingLabel) {
//         await axios.put(
//           `${API_URL}/api/taskLabel/${editingLabel.taskLabelId}`,
//           { name: labelForm.name, color: labelForm.color },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       } else {
//         await axios.post(
//           `${API_URL}/api/taskLabel`,
//           { name: labelForm.name, color: labelForm.color, companyId },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }
//       closeModal();
//       fetchTaskLabels();
//     } catch (error) {
//       console.error("Failed to save label", error);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`${API_URL}/api/taskLabel/${confirmDeleteId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setConfirmDeleteId(null);
//       fetchTaskLabels();
//     } catch (error) {
//       console.error("Delete failed", error);
//     }
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setLabelForm({ name: "", color: colors[0] });
//     setEditingLabel(null);
//   };

//   return (
//     <div className="p-2 bg-gray-100 shadow-lg dark:bg-gray-900 dark:text-white">
//       <div className="flex justify-between items-center mb-4 dark:bg-gray-900 dark:text-white">
//         <h2 className="text-xl font-bold">Task Label</h2>
//         <div className="flex justify-end items-center gap-2">
//           <button
//             onClick={() => setShowModal(true)}
//             className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
//           >
//             <FaPlus /> Add
//           </button>
//           <button
//             onClick={() => setShowFields(!showFields)}
//             className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
//           >
//             <FaSearch />
//             {showFields ? "Close" : "Search"}
//           </button>
//         </div>
//       </div>

//       {showFields && (
//         <div className="mb-4 flex flex-wrap gap-2 items-center">
//           <input
//             type="text"
//             placeholder="Search task label..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="border px-3 py-2 rounded w-full md:w-1/3 dark:bg-gray-700"
//           />
//           <button
//             onClick={() => {
//               const filtered = taskLabels.filter(label =>
//                 label.name.toLowerCase().includes(searchTerm.toLowerCase())
//               );
//               setTaskLabels(filtered);
//             }}
//             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//           >
//             Search
//           </button>
//           <button
//             onClick={() => {
//               setSearchTerm("");
//               fetchTaskLabels();
//             }}
//             className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
//           >
//             Clear
//           </button>
//         </div>
//       )}

//       <div className="overflow-x-auto">
//         <table className="w-full border">
//           <thead className="bg-gray-50 dark:bg-gray-800 dark:text-white">
//             <tr>
//               <th className="px-4 py-2 text-left">Label</th>
//               <th className="px-4 py-2 text-left">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {taskLabels.map((label) => (
//               <tr key={label.taskLabelId} className="border-t">
//                 <td className="px-4 py-2">
//                   <span
//                     className="inline-block px-3 py-1 rounded-full text-white"
//                     style={{ backgroundColor: label.color || "#6b7280" }}
//                   >
//                     {label.name}
//                   </span>
//                 </td>
//                 <td className="px-4 py-2 flex gap-4">
//                   <button
//                     onClick={() => {
//                       setLabelForm({ name: label.name, color: label.color });
//                       setEditingLabel(label);
//                       setShowModal(true);
//                     }}
//                     className="text-yellow-500 hover:text-yellow-700"
//                   >
//                     <FaEdit />
//                   </button>
//                   <button
//                     onClick={() => setConfirmDeleteId(label.taskLabelId)}
//                     className="text-red-600 hover:text-red-800"
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Modal for Create/Edit */}
//       {showModal && (
//          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//           <div className="bg-white rounded-lg p-6 w-full max-w-md dark:bg-gray-800 dark:text-white">
//             <h2 className="text-xl font-bold mb-4">
//               {editingLabel ? "Edit" : "Create"} Label
//             </h2>
//             <input
//               type="text"
//               value={labelForm.name}
//               onChange={(e) =>
//                 setLabelForm({ ...labelForm, name: e.target.value })
//               }
//               className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-700"
//               placeholder="Label Name"
//             />
//             <div className="flex flex-wrap gap-2 mb-4">
//               {colors.map((color) => (
//                 <span
//                   key={color}
//                   onClick={() => setLabelForm({ ...labelForm, color })}
//                   className={`w-6 h-6 rounded-full cursor-pointer border-2 ${
//                     labelForm.color === color ? "border-black" : "border-white"
//                   }`}
//                   style={{ backgroundColor: color }}
//                 ></span>
//               ))}
//             </div>
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={closeModal}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-500"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSave}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//               >
//                 {editingLabel ? "Update" : "Create"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirm Delete Modal */}
//       {confirmDeleteId && (
//          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//           <div className="bg-white rounded-lg p-6 w-full max-w-sm dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg font-bold mb-4">
//               Are you sure you want to delete this label?
//             </h2>
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setConfirmDeleteId(null)}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-500"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TaskLabel;




import React, { useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";

const colors = [
  "#0000FF", "#ff7687", "#f87171", "#fb923c", "#facc15", "#4ade80",
  "#34d399", "#2dd4bf", "#38bdf8", "#60a5fa", "#818cf8", "#a78bfa",
  "#e879f9", "#f472b6", "#f9a8d4", "#c084fc", "#fcd34d", "#86efac",
  "#5eead4", "#67e8f9"
];

const TaskLabel = () => {
  const { user } = useContext(AuthContext);
  const [taskLabels, setTaskLabels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFields, setShowFields] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [labelForm, setLabelForm] = useState({ name: "", color: colors[0] });
  const [editingLabel, setEditingLabel] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const token = localStorage.getItem("token");
  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  const fetchTaskLabels = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/taskLabel/company/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTaskLabels(response.data);
    } catch (error) {
      console.error("Error fetching task labels", error);
    }
  }, [companyId, token]);

  useEffect(() => {
    fetchTaskLabels();
  }, [fetchTaskLabels]);

  const handleSave = async () => {
    try {
      if (editingLabel) {
        await axios.put(
          `${API_URL}/api/taskLabel/${editingLabel.taskLabelId}`,
          { name: labelForm.name, color: labelForm.color },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${API_URL}/api/taskLabel`,
          { name: labelForm.name, color: labelForm.color, companyId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      closeModal();
      fetchTaskLabels();
    } catch (error) {
      console.error("Failed to save label", error);
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/api/taskLabel/${confirmDeleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfirmDeleteId(null);
      fetchTaskLabels();
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setLabelForm({ name: "", color: colors[0] });
    setEditingLabel(null);
  };

  return (
    <div className="p-2 bg-[#FAF8FF] shadow-lg cfg-font dark:bg-gray-900 dark:text-white">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
            <div className="flex justify-between items-center mb-4 dark:bg-gray-900 dark:text-white">
        <h2 className="text-xl font-bold cfg-heading">Task Label</h2>
        <div className="flex justify-end items-center gap-2">
          <button
            onClick={() => setShowModal(true)}
            className="px-2 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2"
          >
            <FaPlus /> Add
          </button>
          <button
            onClick={() => setShowFields(!showFields)}
            className="px-2 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2"
          >
            <FaSearch />
            {showFields ? "Close" : "Search"}
          </button>
        </div>
      </div>

      {showFields && (
        <div className="mb-4 flex flex-wrap gap-2 items-center">
          <input
            type="text"
            placeholder="Search task label..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-[#E5E7EB] px-3 py-2 rounded w-full md:w-1/3 dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
          />
          <button
            onClick={() => {
              const filtered = taskLabels.filter(label =>
                label.name.toLowerCase().includes(searchTerm.toLowerCase())
              );
              setTaskLabels(filtered);
            }}
            className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
          >
            Search
          </button>
          <button
            onClick={() => {
              setSearchTerm("");
              fetchTaskLabels();
            }}
            className="bg-[#F3F4F6] text-[#374151] px-4 py-2 rounded hover:bg-[#E5E7EB]"
          >
            Clear
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border border-[#E5E7EB] rounded-lg overflow-hidden">
          <thead className="bg-[#F3F4F6] dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="px-4 py-2 text-left">Label</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {taskLabels.map((label) => (
              <tr key={label.taskLabelId} className="border-t">
                <td className="px-4 py-2">
                  <span
                    className="inline-block px-3 py-1 rounded-full text-white"
                    style={{ backgroundColor: label.color || "#6b7280" }}
                  >
                    {label.name}
                  </span>
                </td>
                <td className="px-4 py-2 flex gap-4">
                  <button
                    onClick={() => {
                      setLabelForm({ name: label.name, color: label.color });
                      setEditingLabel(label);
                      setShowModal(true);
                    }}
                    className="text-[#8B5CF6] hover:text-[#673AB7]"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => setConfirmDeleteId(label.taskLabelId)}
                    className="text-[#EF4444] hover:text-[#B91C1C]"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal for Create/Edit */}
      {showModal && (
         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl p-6 w-full max-w-md dark:bg-gray-800 dark:text-white shadow-xl">
            <h2 className="text-xl font-bold mb-4 cfg-heading">
              {editingLabel ? "Edit" : "Create"} Label
            </h2>
            <input
              type="text"
              value={labelForm.name}
              onChange={(e) =>
                setLabelForm({ ...labelForm, name: e.target.value })
              }
              className="w-full border border-[#E5E7EB] px-3 py-2 mb-4 rounded dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              placeholder="Label Name"
            />
            <div className="flex flex-wrap gap-2 mb-4">
              {colors.map((color) => (
                <span
                  key={color}
                  onClick={() => setLabelForm({ ...labelForm, color })}
                  className={`w-6 h-6 rounded-full cursor-pointer border-2 ${
                    labelForm.color === color ? "border-black" : "border-white"
                  }`}
                  style={{ backgroundColor: color }}
                ></span>
              ))}
            </div>
            <div className="flex justify-end gap-2">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB] dark:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6]"
              >
                {editingLabel ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDeleteId && (
         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm dark:bg-gray-800 dark:text-white shadow-xl">
            <h2 className="text-lg font-bold mb-4 cfg-heading">
              Are you sure you want to delete this label?
            </h2>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setConfirmDeleteId(null)}
                className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB] dark:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-[#EF4444] text-white rounded hover:bg-[#B91C1C]"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskLabel;
